import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers([
  'container',
  'imageContainer',
  'imageLink',
  'image',
  'content',
  'metaRow',
  'category',
  'publishedDate',
  'title',
  'titleLink',
  'description',
  'ctaSlot',
  'tagsContainer',
  'tag',
  'tagText'
]);

export const blogSummaryStyles = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 4, md: 5},
      alignSelf: 'stretch',
      flex: '1 0 0',
      transition: 'transform 0.2s ease',
      _hover: {
        transform: 'translateY(-2px)',
      },
    },

    imageContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'stretch',
      aspectRatio: {base: '67/60', md: '1/1'},
      overflow: 'hidden',
    },

    imageLink: {
      cursor: 'pointer',
      display: 'block',
      width: '100%',
      height: '100%',
    },

    image: {
      width: '100%',
      height: '100%',

      sx: {
        img: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        },
      },
    },

    content: {
      cursor: 'default',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 0,
      alignSelf: 'stretch',
    },

    metaRow: {
      alignSelf: 'stretch',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      columnGap: 4,
      rowGap: 2,
      mb: 2,
    },

    category: {
      alignSelf: 'stretch',
      cursor: 'default',
      color: 'brandColors.primaryDarkLinen',
      fontFamily: 'heading',
      fontSize: '10px',
      fontWeight: '600',
      lineHeight: '120%',
      letterSpacing: '2px',
      textTransform: 'uppercase',
    },

    publishedDate: {
      color: 'brandColors.greyscale70',
      fontFamily: 'heading',
      fontSize: '10px',
      fontStyle: 'normal',
      fontWeight: '600',
      lineHeight: '120%',
      letterSpacing: '2px',
      textTransform: 'uppercase',
      flexShrink: 0,
    },

    title: {
      alignSelf: 'stretch',
      color: 'brandColors.greyscale90',
      fontFamily: 'heading',
      fontSize: {base: '16px', md: '20px'},
      fontWeight: '500',
      lineHeight: '120%',
      letterSpacing: {base: '0', md: '0'},
      mb: 0,
    },

    titleLink: {
      cursor: 'pointer',
      display: 'block',
      textDecoration: 'none',
      transition: 'color 0.2s ease',
      _hover: {
        textDecoration: 'underline',
      },
      _focusVisible: {
        outline: '2px solid',
        outlineColor: 'brandColors.primaryDarkLinen',
        outlineOffset: '2px',
      },
    },

    description: {
      alignSelf: 'stretch',
      color: {base: 'brandColors.greyscale90', md: 'brandColors.greyscale80'},
      fontFamily: 'body',
      fontSize: {base: '14px', md: '18px'},
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: {base: '140%', md: '160%'},
    },

    ctaSlot: {
      alignSelf: 'flex-start',
      mt: 0,
    },

    tagsContainer: {
      cursor: 'default',
      display: 'flex',
      alignItems: 'flex-start',
      gap: 2,
      flexWrap: 'wrap',
    },

    tag: {
      cursor: 'default',
      display: 'flex',
      padding: '4px 8px',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '32px',
      border: '1px solid',
      borderColor: 'brandColors.linen03',
      backgroundColor: 'transparent',
      height: '22px',
    },

    tagText: {
      cursor: 'default',
      color: 'brandColors.greyscale90',
      fontSize: '12px',
      fontWeight: '400',
      lineHeight: '140%',
    },
  },

  variants: {
    /**
     * Featured variant - horizontal layout with large image
     */
    featured: {
      container: {
        display: 'flex',
        flexDirection: {base: 'column', md: 'row'},
        alignItems: 'stretch',
        gap: 0,
        width: '100%',
        _hover: {
          transform: 'none',
        },
      },

      imageContainer: {
        flex: {base: '1', md: '0 0 65%'},
        aspectRatio: {base: '335/300', md: '840/468'},
        overflow: 'hidden',
      },

      imageLink: {
        cursor: 'pointer',
        display: 'block',
        width: '100%',
        height: '100%',
      },

      image: {
        width: '100%',
        height: '100%',

        sx: {
          img: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          },
        },
      },

      content: {
        cursor: 'default',
        flex: {base: '1', md: '0 0 35%'},
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        gap: 0,
        padding: {base: '32px 20px', md: '48px'},
        backgroundColor: 'brandColors.primaryBG',
      },

      category: {
        cursor: 'default',
        color: 'greyscale.80',
        fontFamily: 'heading',
        fontSize: '10px',
        fontWeight: '600',
        lineHeight: '120%',
        letterSpacing: '2px',
        textTransform: 'uppercase',
      },

      title: {
        color: 'brandColors.greyscale90',
        fontFamily: 'heading',
        fontSize: {base: '24px', md: '32px'},
        fontWeight: '400',
        lineHeight: '120%',
        letterSpacing: {base: '-0.24px', md: '-0.32px'},
        mb: 0,
      },

      tagsContainer: {
        display: 'none',
      },

      tag: {
        display: 'none',
      },

      tagText: {
        display: 'none',
      },
    },
  },
});
